import type { IconName } from './iconNames';

export const FONT_AWESOME_GLYPHS: Record<IconName, string> = {
  camera: 'camera',
  'camera-rotate': 'camera-rotate',
  check: 'check',
  'chevron-down': 'chevron-down',
  'chevron-left': 'chevron-left',
  'chevron-right': 'chevron-right',
  'chevron-up': 'chevron-up',
  'circle-plus': 'circle-plus',
  clock: 'clock',
  close: 'xmark',
  'comment-dots': 'comment-dots',
  'comment-slash': 'comment-slash',
  comments: 'comments',
  compress: 'compress',
  copy: 'copy',
  crosshairs: 'location-crosshairs',
  ellipsis: 'ellipsis',
  expand: 'expand',
  house: 'house',
  image: 'image',
  info: 'circle-info',
  'kit-medical': 'kit-medical',
  lightbulb: 'lightbulb',
  language: 'language',
  'layer-group': 'layer-group',
  'map-pin': 'location-dot',
  mobile: 'mobile-screen',
  'paper-plane': 'paper-plane',
  paperclip: 'paperclip',
  pencil: 'pencil',
  phone: 'phone',
  'phone-hangup': 'phone-slash',
  play: 'play',
  plus: 'plus',
  question: 'circle-question',
  refresh: 'arrow-rotate-right',
  route: 'route',
  search: 'magnifying-glass',
  share: 'share-nodes',
  'shield-heart': 'shield-heart',
  signal: 'signal',
  siren: 'truck-medical',
  tag: 'tag',
  'tower-cell': 'tower-cell',
  video: 'video',
  'video-off': 'video-slash',
  warning: 'triangle-exclamation',
};
